import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { DirectBudgetHeader } from './directbudget.models';

const money = (v: number) =>
  Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

export default class DirectBudgetSummary extends React.PureComponent<{
  value: DirectBudgetHeader;
}> {
  render() {
    const v = this.props.value;
    const cards = [
      ['Ceiling', money(v.ceilingamount)],
      ['Requested', money(v.requestedamount)],
      ['Available', money(v.availableamount)],
      ['Utilisation', `${v.utilisationpercent.toFixed(1)}%`],
      ['Lines', String(v.linecount)],
    ];
    return (
      <Grid container spacing={2}>
        {cards.map(([l, x]) => (
          <Grid size={{ xs: 12, sm: 6, md: 2.4 }} key={l}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="caption" color="text.secondary">
                  {l}
                </Typography>
                <Typography variant="h6" fontWeight={700}>
                  {x}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}
